var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GlobalWindow',{attrs:{"visible":_vm.visible,"confirm-working":_vm.isWorking,"width":"582px","title":"配置用户角色"},on:{"update:visible":function($event){_vm.visible=$event},"confirm":_vm.confirm}},[(_vm.user != null)?_c('p',{staticClass:"tip"},[_vm._v("为用户 "),_c('em',[_vm._v(_vm._s(_vm.user.realname))]),_vm._v(" 配置角色")]):_vm._e(),_c('el-transfer',{attrs:{"titles":['未授权角色', '已授权角色'],"props":{
      key: 'id',
      label: 'name'
    },"data":_vm.roles},model:{value:(_vm.selectedIds),callback:function ($$v) {_vm.selectedIds=$$v},expression:"selectedIds"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }